import { DataHubPath } from './const';

export const DATA_HUB_BASE_PATH = '/data-hub';

export const dataHubRoutes = {
  base: DATA_HUB_BASE_PATH,
  exportSelection: `${DATA_HUB_BASE_PATH}/${DataHubPath.EXPORT_SELECTION}`,
  pastExports: `${DATA_HUB_BASE_PATH}/${DataHubPath.PAST_EXPORTS}`
} as const;
